import { RouteObject } from 'react-router-dom'
import { ROUTES } from '.'
import { Admin, AdminMaster, ReimpresionInforme, TableEtapas, TableGroups, TablePerfiles, TableSectoresComerciales, TableUnidadesNegocio, TableUsers, ReporteDetalleSistemaGrupo, ReporteSeguridadWorkflow, TableClienteTipo, TableClienteTipoLCTC, ConfigSectorSistemaGrupo, TableEtapaEnvioMail, TableObjetosSeguridad, ConfigPermisos, TableInstrumentosLCSLHPTI, WFInicioFirmaAdmin } from '../pages'
import ConfigEtapaGrupoPermiso from '../pages/cruds/etapa-grupo-permiso/ConfigEtapaGrupoPermiso'
import ConfigRelaciones from '../pages/cruds/cliente-tipo/ConfigRelaciones'
import ConfigRelacionesLCTC from '../pages/cruds/cliente-tipo-lctc/ConfigRelacionesLCTC'
import ReportesPage from '../pages/cruds/reportes/ReportesPage'
import { SafetyRoute } from 'src/components/security'
import { AdminPanelSecObjects, AppSecObjects } from 'src/types/security'
import TablaEventos from '../pages/eventos/components/TablaEventos'

export const adminRouter: RouteObject[] = [
    {
        path: ROUTES.PANEL,
        element: (
            <SafetyRoute code={AppSecObjects.RutaPanelAdmin}>
                <Admin />
            </SafetyRoute>
        )
    },
    {
        path: ROUTES.ADMIN_MASTER,
        element: (
            <SafetyRoute code={AppSecObjects.RutaAdminMaster}>
                <AdminMaster />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.ADMIN_MASTER}/${ROUTES.REIMPRESION}`,
        element: (
            <SafetyRoute code={AppSecObjects.RutaAdminMaster}>
                <ReimpresionInforme />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.USUARIOS}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaUsuarios}>
                <TableUsers />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.GRUPOS}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaGrupos}>
                <TableGroups />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.SECTORES_COMERCIALES}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaSectoresComerciales}>
                <TableSectoresComerciales />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.ADMIN_MASTER}/${ROUTES.ETAPAS}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaEtapas}>
                <TableEtapas />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.PERFILES}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaPerfiles}>
                <TablePerfiles />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.UNIDADES_NEGOCIO}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaUnidadesNegocio}>
                <TableUnidadesNegocio />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.REPORTES}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaReportes}>
                <ReportesPage />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.REPORTE_DETALLE_SISTEMA_GRUPO}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaReportes}>
                <ReporteDetalleSistemaGrupo />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.REPORTE_SEGURIDAD_WORKFLOW}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaReportes}>
                <ReporteSeguridadWorkflow />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaClienteTipo}>
                <TableClienteTipo />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO_RELACIONES}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaClienteTipo}>
                <ConfigRelaciones />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO_LCTC}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaClienteTipoLCTC}>
                <TableClienteTipoLCTC />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.CLIENTE_TIPO_LCTC_RELACIONES}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaClienteTipoLCTC}>
                <ConfigRelacionesLCTC />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.INSTRUMENTOS_LCSLHPTI}`,
        element: (
            <SafetyRoute code={AppSecObjects.RutaPanelAdmin}>
                <TableInstrumentosLCSLHPTI />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.SECTOR_SISTEMA_GRUPO}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaSectorSistemaGrupo}>
                <ConfigSectorSistemaGrupo />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.ETAPA_ENVIO_MAIL}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaEtapaEnvioMail}>
                <TableEtapaEnvioMail />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.EVENTOS}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaEventos}>
                <TablaEventos />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.OBJETOS_SEGURIDAD}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaObjetosSeguridad}>
                <TableObjetosSeguridad />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.PANEL}/${ROUTES.PERMISOS}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaPermisos}>
                <ConfigPermisos />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.ADMIN_MASTER}/${ROUTES.ETAPA_GRUPO_PERMISO}`,
        element: (
            <SafetyRoute code={AdminPanelSecObjects.LinkTablaEtapaGrupoPermiso}>
                <ConfigEtapaGrupoPermiso />
            </SafetyRoute>
        )
    },
    {
        path: `${ROUTES.ADMIN_MASTER}/${ROUTES.WF_INICIO_FIRMA}`,
        element: (
            <SafetyRoute code={AppSecObjects.RutaAdminMaster}>
                <WFInicioFirmaAdmin />
            </SafetyRoute>
        )
    }
]
